import { PipeTransform, Pipe } from '@angular/core';

@Pipe({name: 'MapPropertyList'})
export class MapPropertyListPipe implements PipeTransform {
  transform(input: any[], propertyName: string): any {
      return (input || []).map(value => this.evalValue(value, propertyName)).join(', ');
  }

  evalValue(object, propertyName) {
    propertyName = propertyName || '';
    if (propertyName.indexOf('.') < 0) {
      return object[propertyName];
    } else {
      const dotAnotationSegments = propertyName.split('.');
      let value = object;
      for (let s of dotAnotationSegments) {
        value = value[s];
      }
      return value;
    }
  }
}
